import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Badge, Table } from 'reactstrap';
import { Eye, CheckCircle, X, Calendar, Award, Clock } from 'react-feather';

const UserDetailModal = ({ isOpen, toggle, user, loading, formatDate }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle} className="bg-light">
        <h5 className="mb-0">
          <Eye size={20} className="me-2" />
          Chi tiết người dùng
        </h5>
      </ModalHeader>
      <ModalBody className="p-4">
        {loading && (
          <div className="text-center py-5">
            <div className="spinner-border text-primary mb-3">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-muted">Đang tải thông tin...</p>
          </div>
        )}

        {!loading && user && (
          <>
            {/* User Info */}
            <div className="mb-4">
              <h5 className="mb-3 pb-2 border-bottom">Thông tin cơ bản</h5>
              <Row>
                <Col md="6" className="mb-3">
                  <label className="small text-muted">USER ID</label>
                  <p className="mb-0 font-monospace">{user.userId}</p>
                </Col>
                <Col md="6" className="mb-3">
                  <label className="small text-muted">TÊN</label>
                  <p className="mb-0">{user.name || '-'}</p>
                </Col>
                <Col md="6" className="mb-3">
                  <label className="small text-muted">SỐ ĐIỆN THOẠI</label>
                  <p className="mb-0">{user.phone || '-'}</p>
                </Col>
                <Col md="6" className="mb-3">
                  <label className="small text-muted">ROLE CODE</label>
                  <p className="mb-0">
                    <Badge color="info" className="px-3 py-2">
                      {user.role_code || 'N/A'}
                    </Badge>
                  </p>
                </Col>
                <Col md="6" className="mb-3">
                  <label className="small text-muted">FOLLOWED OA</label>
                  <p className="mb-0">
                    {user.followedOA ? (
                      <Badge color="success" className="px-3 py-2">
                        <CheckCircle size={14} className="me-1" />
                        Đã follow
                      </Badge>
                    ) : (
                      <Badge color="secondary" className="px-3 py-2">
                        <X size={14} className="me-1" />
                        Chưa follow
                      </Badge>
                    )}
                  </p>
                </Col>
                <Col md="6" className="mb-3">
                  <label className="small text-muted">
                    <Calendar size={12} className="me-1" />
                    NGÀY TẠO
                  </label>
                  <p className="mb-0 small">{formatDate(user.createdAt)}</p>
                </Col>
              </Row>
            </div>

            {/* Quiz Attempts */}
            <div>
              <h5 className="mb-3 pb-2 border-bottom">
                <Award size={20} className="me-2" />
                Lịch sử làm Quiz ({user.quizAttempts?.length || 0})
              </h5>
              
              {!user.quizAttempts || user.quizAttempts.length === 0 ? (
                <div className="text-center py-4 bg-light rounded">
                  <Award size={48} className="text-muted opacity-50 mb-2" />
                  <p className="text-muted mb-0">Chưa có lịch sử làm quiz</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <Table size="sm" bordered className="mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Tên Quiz</th>
                        <th>Điểm</th>
                        <th>Trạng thái</th>
                        <th>Hoàn thành</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user.quizAttempts.map((attempt, index) => (
                        <tr key={attempt.id}>
                          <td>{index + 1}</td>
                          <td>{attempt.name || `Quiz #${attempt.quizId}`}</td>
                          <td>
                            <span className="fw-bold text-warning">
                              {attempt.score || 0}
                            </span>
                          </td>
                          <td>
                            <Badge 
                              color={attempt.status === 'completed' ? 'success' : 'warning'}
                              className="px-2"
                            >
                              {attempt.status === 'completed' ? (
                                <>
                                  <CheckCircle size={12} className="me-1" />
                                  Hoàn thành
                                </>
                              ) : (
                                <>
                                  <Clock size={12} className="me-1" />
                                  {attempt.status}
                                </>
                              )}
                            </Badge>
                          </td>
                          <td className="small">{formatDate(attempt.completedAt)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter className="bg-light">
        <Button color="secondary" onClick={toggle}>
          Đóng
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UserDetailModal;

